var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "spwwIndexPage" },
    [
      _c("Header"),
      _vm._v(" "),
      _c("Body"),
      _vm._v(" "),
      _c("Footer"),
      _vm._v(" "),
      _c("el-backtop", { attrs: { target: ".spwwIndexPage" } }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }